import { graphql } from 'react-apollo'
import { Layout, Table } from 'antd'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import React from 'react'

import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import productGroupQuery from '../graphql/queries/productGroup'

import '../css/table.css'

const { Content } = Layout

const ProductGroup = (props) => {
  const { productGroup: { loading, productGroup = [] } } = props
  const groups = productGroup.map(group => ({ group })).reverse()
  const columns = [
    {
      title: 'Group',
      key: 'group',
      render: record => (<Link to={`/product/${record.group}`}>{record.group}</Link>),
    },
  ]
  return (
    <Layout>
      <Navbar selected="product:1" />
      <Content style={{ padding: '0 20px' }}>
        <div style={{ background: '#fff', padding: 24, minHeight: 'calc(100vh - 64px - 69px)' }}>
          <h2>Product Group</h2>
          <Table
            dataSource={groups}
            columns={columns}
            rowKey="group"
            pagination={{ pageSize: 50 }}
            size="middle"
            loading={loading}
            bordered
          />
        </div>
      </Content>
      <Footer />
    </Layout>
  )
}
ProductGroup.propTypes = {
  productGroup: PropTypes.shape({
    error: PropTypes.object,
    loading: PropTypes.bool,
    productGroup: PropTypes.array,
  }).isRequired,
}
ProductGroup.defaultProps = {}

export default graphql(productGroupQuery, { name: 'productGroup' })(ProductGroup)



// WEBPACK FOOTER //
// ./src/pages/ProductGroup.js